<template>
  <div class="login">
    <div class="login-form">
      <span class="login-word">登录</span>
      <div class="login-form-item zhanghaoInput">
        <span class="login-form-item-span">账号</span>
        <el-input v-model="user_name" placeholder="请输入内容"></el-input>
      </div>
      <div class="login-form-item">
        <span class="login-form-item-span">密码</span>
        <el-input placeholder="请输入密码" v-model="password" show-password></el-input>
      </div>
      <div class="login-form-remember" :style="{ 'justify-content': isError ? '' : 'flex-end' }">
        <span v-if="isError" class="login-form-error">*账号或密码错误</span>
        <el-checkbox v-model="isRemamber">记住密码</el-checkbox>
      </div>
      <el-button type="primary" @click="handleLogin">登录</el-button>
    </div>
  </div>
</template>

<script>
import { PostLogin } from '../api/api'
export default {
  data () {
    return {
      isError: false,
      isRemamber: false,
      user_name: '',
      password: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      // 记住密码回显操作
      if (localStorage.getItem('isRemamber')) {
        this.password = localStorage.getItem('password')
        this.user_name = JSON.parse(localStorage.getItem('user_info')).user_name
        this.isRemamber = true
      }
    },
    async handleLogin () {
      // 用户名及密码验证
      if (!this.user_name) {
        return this.$message.warning('账号不能为空')
      }
      if (!this.password) {
        this.isError = true
        return false
      }
      // 删除密码未输入校验
      this.isError = false
      // 解构赋值获取数据
      const { user_name, password } = this
      // 入参
      const params = {
        user_name,
        password
      }
      await PostLogin(params).then(res => {
        if (res) {
          // 如果勾选记住密码，将密码存入localstorage，状态必存
          if (this.isRemamber) {
            localStorage.setItem('password', password)
          } else {
            localStorage.removeItem('password')
          }
          localStorage.setItem('isRemamber', this.isRemamber)
          // 保存用户数据
          localStorage.setItem('user_info', JSON.stringify(res.data))
          this.$message.success('登录成功')
          // this.$router.push('/home')
          this.$router.push('/show')
        }
      })
    }
  }
}
</script>

<style lang="less">
.login {
  position: relative;
  width: 100%;
  height: 100%;
  background: rgb(152, 183, 241);
  .login-word {
    display: inline-block;
    margin: 27.5px 0 30.5px 0;
    font-size: 24px;
    letter-spacing: 4px;
    color: #0c75ff;
  }
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 379px;
    height: 365px;
    border-radius: 5px;
    box-shadow: 0px 1px 6px 1px rgba(34, 82, 177, 0.07);
    background: #fff;
    padding: 0 36.5px;
    display: flex;
    flex-direction: column;
    .login-form-item-span {
      display: inline-block;
      font-size: 8px;
      margin-bottom: 5.5px;
      transform: scale(0.9);
    }
  }
  .zhanghaoInput {
    margin-bottom: 18.5px;
  }
  .login-form-remember {
    width: 125%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 7.5px 0 18.5px 0;
    font-size: 7px;
    transform: scale(0.8) translateX(-48px);
    .login-form-error {
      color: #ff4b42;
    }
  }
  .el-button {
    width: 75%;
    margin: 0 auto;
    background: #0c75ff;
    border-radius: 3px;
    letter-spacing: 4px;
  }
}
</style>
